import BaseProxy from './Proxy';

export default class SubstoreChangeActionProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/substore/productChangeAction', parameters);
  }
}
